// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__SqDAN","title":"ClientInsurance_title__3LbAa","itemText":"ClientInsurance_itemText__eT4we"};